import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isDataLoading: false,
      createProfile: {
        form: {
          name: {
            type: 'input',
            name: 'name',
            label: 'Name',
            placeholder: 'Name',
            validation: [{ name: 'required' }],
            value: null,
            class: 'col-12'
          },
          position: {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            validation: [{ name: 'required' }],
            value: null,
            class: 'col-12'
          },
          payment_type: {
            type: 'select',
            name: 'payment_type',
            label: 'Payment type',
            options: [],
            value: null,
            class: 'col-md-6 payment-type',
            labelClass: 'text-lowercase'
          },
          employment_type: {
            type: 'select',
            name: 'employment_type',
            label: 'Employment type',
            valueField: 'id',
            selectLabel: 'name',
            options: [],
            value: null,
            class: 'col-md-6',
            labelClass: 'text-lowercase'
          },
          partner: {
            type: 'select',
            name: 'partner_id',
            label: 'Partner name',
            placeholder: 'Select partner name',
            valueField: 'id',
            selectLabel: 'company_name',
            value: null,
            class: 'col-md-12',
            hidden: true,
            options: []
          },
          allocations: {
            type: 'multiselect',
            name: 'allocations',
            nameItem: 'allocations',
            label: 'Allocation',
            valueField: 'id',
            selectLabel: 'name',
            placeholder: 'Select allocation',
            value: [],
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          availability: {
            type: 'select',
            name: 'availability',
            label: 'Availability',
            valueField: 'id',
            selectLabel: 'name',
            placeholder: 'Select availability',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          seniority_lvl: {
            type: 'select',
            name: 'seniority_lvl',
            label: 'Seniority level',
            valueField: 'id',
            selectLabel: 'name',
            placeholder: 'Select level',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          english_lvl: {
            type: 'select',
            name: 'english_lvl',
            label: 'English level',
            valueField: 'id',
            selectLabel: 'name',
            placeholder: 'Select level',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          years_of_experience: {
            type: 'input',
            typeInput: 'number',
            name: 'years_of_experience',
            label: 'Years of experience',
            placeholder: 'Years',
            validation: [{ name: 'required' }],
            value: 3,
            class: 'col-12'
          },
          skills: {
            type: 'slot',
            slotName: 'skills',
            name: 'skills',
            label: 'Skills',
            class: 'col-12',
            value: []
          },
          cv_link: {
            type: 'input',
            name: 'cv_link',
            label: 'CV',
            placeholder: 'Link to CV',
            value: null,
            class: 'col-12'
          },
          show_on_widget: {
            type: 'switch',
            name: 'show_on_widget',
            label: 'Show on profiles widget',
            value: false,
            class: 'col-12'
          }
        }
      },
      editProfile: {
        showModal: false,
        showAvatarCropModal: false,
        showConvertIntoUserModal: false,
        avatarFile: null,
        form: {
          'id': {
            name: 'id',
            value: null,
            hidden: true
          },
          'name': {
            type: 'input',
            name: 'name',
            label: 'Name',
            placeholder: 'Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'position': {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'payment_type': {
            type: 'select',
            name: 'payment_type',
            label: 'Payment type',
            options: [],
            value: null,
            class: 'col-md-6 payment-type',
            labelClass: 'text-lowercase'
          },
          'employment_type': {
            type: 'select',
            name: 'employment_type',
            label: 'Employment type',
            selectLabel: 'name',
            valueField: 'id',
            options: [],
            value: null,
            class: 'col-md-6',
            labelClass: 'text-lowercase'
          },
          'partner': {
            type: 'select',
            name: 'partner_id',
            label: 'Partner name',
            placeholder: 'Select partner name',
            valueField: 'id',
            selectLabel: 'company_name',
            value: null,
            class: 'col-md-12',
            hidden: true
          },
          'roles': {
            type: 'multiselect',
            name: 'roles',
            label: 'Roles',
            valueField: 'id',
            selectLabel: 'display_name',
            placeholder: 'Roles',
            options: [],
            value: null,
            class: 'col-12',
            hidden: true
          },
          allocations: {
            type: 'multiselect',
            name: 'allocations',
            nameItem: 'allocations',
            label: 'Allocation',
            valueField: 'id',
            selectLabel: 'name',
            placeholder: 'Select allocation',
            value: [],
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          availability: {
            type: 'select',
            name: 'availability',
            label: 'Availability',
            selectLabel: 'name',
            valueField: 'id',
            placeholder: 'Select availability',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          years_of_experience: {
            type: 'input',
            typeInput: 'number',
            name: 'years_of_experience',
            label: 'Years of experience',
            placeholder: 'Years',
            value: 3,
            class: 'col-12'
          },
          seniority_lvl: {
            type: 'select',
            name: 'seniority_lvl',
            label: 'Seniority level',
            selectLabel: 'name',
            valueField: 'id',
            placeholder: 'Select level',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          english_lvl: {
            type: 'select',
            name: 'english_lvl',
            label: 'English level',
            selectLabel: 'name',
            valueField: 'id',
            placeholder: 'Select level',
            value: null,
            class: 'col-md-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          cv_link: {
            type: 'input',
            name: 'cv_link',
            label: 'CV',
            placeholder: 'Link to CV',
            value: null,
            class: 'col-12'
          },
          mobile: {
            type: 'input',
            name: 'mobile',
            label: 'Mobile',
            placeholder: 'Mobile',
            value: null,
            class: 'col-6',
            hidden: true
          },
          telegram: {
            type: 'input',
            name: 'telegram',
            label: 'Telegram',
            placeholder: 'Telegram',
            value: null,
            class: 'col-6',
            hidden: true
          },
          skype: {
            type: 'input',
            name: 'skype',
            label: 'Skype',
            placeholder: 'Skype',
            value: null,
            class: 'col-6',
            hidden: true
          },
          other: {
            type: 'input',
            name: 'other',
            label: 'Other contact',
            placeholder: 'Other contact',
            value: null,
            class: 'col-6',
            hidden: true
          },
          skills: {
            type: 'slot',
            slotName: 'skills',
            name: 'skills',
            label: 'Skills',
            class: 'col-12',
            value: []
          },
          show_on_widget: {
            type: 'checkbox',
            name: 'show_on_widget',
            label: 'Show on profiles widget',
            value: false,
            class: 'col-6'
          },
          is_contact_person: {
            type: 'checkbox',
            name: 'is_contact_person',
            label: 'Contact person',
            value: false,
            class: 'col-6',
            hidden: true
          }
        }
      }
    }
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getAllocations: 'users/getAllocations',
      getAvailability: 'users/getAvailability',
      getEmploymentTypes: 'users/getEmploymentTypes',
      getEnglishLevels: 'users/getEnglishLevels',
      getPaymentTypes: 'users/getPaymentTypes',
      getSeniorityLevels: 'users/getSeniorityLevels'
    })
  },
  methods: {
    async fetchAllocations () {
      return this.$api.users.getAllocations()
    },
    async fetchAvailability () {
      return this.$api.users.getAvailability()
    },
    async fetchEmploymentTypes () {
      return this.$api.users.getEmploymentTypes()
    },
    async fetchEnglishLevels () {
      return this.$api.users.getEnglishLevels()
    },
    async fetchPaymentTypes () {
      return this.$api.users.getPaymentTypes()
    },
    async fetchSeniorityLevels () {
      return this.$api.users.getSeniorityLevels()
    },
    setVisibleEditModal (status) {
      this.editProfile.showModal = status
    },
    fetchAllData () {
      return Promise.all([
        this.fetchAllocations(),
        this.fetchAvailability(),
        this.fetchEmploymentTypes(),
        this.fetchEnglishLevels(),
        this.fetchPaymentTypes(),
        this.fetchSeniorityLevels()
      ])
        .then(() => {
          this.setAllOptions()
        })
    },
    setAllOptions () {
      this.createProfile.form.allocations.options = this.getAllocations
      this.editProfile.form.allocations.options = this.getAllocations

      this.createProfile.form.availability.options = this.getAvailability
      this.editProfile.form.availability.options = this.getAvailability

      this.createProfile.form.employment_type.options = this.getEmploymentTypes
      this.editProfile.form.employment_type.options = this.getEmploymentTypes

      this.createProfile.form.english_lvl.options = this.getEnglishLevels
      this.editProfile.form.english_lvl.options = this.getEnglishLevels

      this.createProfile.form.payment_type.options = this.getPaymentTypes.map(item => item.id)
      this.editProfile.form.payment_type.options = this.getPaymentTypes.map(item => item.id)

      this.createProfile.form.seniority_lvl.options = this.getSeniorityLevels
      this.editProfile.form.seniority_lvl.options = this.getSeniorityLevels
    },
    handleAvatarFile (e) {
      const file = e.target.files[0]

      if (!file) return

      if (file.type.indexOf('image/') === -1) {
        this.$snotify.error('Please select an image file', 'Error', this.$store.state.snotify)
        return
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.editProfile.avatarFile = event.target.result
          this.editProfile.showAvatarCropModal = true
        }

        reader.readAsDataURL(file)
      } else {
        this.$snotify.error('Sorry, FileReader API not supported', 'Error', this.$store.state.snotify)
      }
    },
    resetAvatarInputAfterModalClose () {
      this.$refs.avatarFile.value = null
      this.editProfile.avatarFile = null
    },
    fillEditUserForm (user) {
      this.editProfile.form.id.value = user.id
      this.editProfile.form.roles.value = user.roles
      this.editProfile.form.roles.options = this._allUserRoles
      this.editProfile.form.roles.hidden = false
      this.editProfile.form.name.value = user.name
      this.editProfile.form.position.value = user.position
      this.editProfile.form.payment_type.value = user.payment_type
      this.editProfile.form.employment_type.value = user.employment_type
      this.editProfile.form.show_on_widget.value = user.show_on_widget === 1 || user.show_on_widget === true
      this.editProfile.form.is_contact_person.value = user.is_contact_person === 1 || user.is_contact_person === true
      this.editProfile.form.is_contact_person.hidden = false
      this.editProfile.form.partner.value = user.partner
      this.editProfile.form.partner.hidden = user.employment_type.type !== 'partner'
      this.editProfile.form.availability.value = user.availability
      this.editProfile.form.years_of_experience.value = user.years_of_experience
      this.editProfile.form.seniority_lvl.value = user.seniority_lvl
      this.editProfile.form.english_lvl.value = user.english_lvl
      this.editProfile.form.cv_link.value = user.cv_link
      this.editProfile.form.allocations.value = user.allocations
      this.editProfile.form.skills.value = user.skills
      let contacts = user.contacts ? user.contacts : {}
      this.editProfile.form.mobile.value = contacts.mobile || null
      this.editProfile.form.mobile.hidden = false
      this.editProfile.form.telegram.value = contacts.telegram || null
      this.editProfile.form.telegram.hidden = false
      this.editProfile.form.skype.value = contacts.skype || null
      this.editProfile.form.skype.hidden = false
      this.editProfile.form.other.value = contacts.other || null
      this.editProfile.form.other.hidden = false
    },
    fillEditUserProfileForm (profile) {
      this.editProfile.form.id.value = profile.id
      this.editProfile.form.roles.value = []
      this.editProfile.form.roles.options = this._allUserRoles
      this.editProfile.form.roles.hidden = true
      this.editProfile.form.name.value = profile.name
      this.editProfile.form.position.value = profile.position
      this.editProfile.form.payment_type.value = profile.payment_type
      this.editProfile.form.employment_type.value = profile.employment_type
      this.editProfile.form.show_on_widget.value = profile.show_on_widget === 1 || profile.show_on_widget === true
      this.editProfile.form.partner.value = profile.partner
      this.editProfile.form.partner.hidden = profile.employment_type.type !== 'partner'
      this.editProfile.form.availability.value = profile.availability
      this.editProfile.form.years_of_experience.value = profile.years_of_experience
      this.editProfile.form.seniority_lvl.value = profile.seniority_lvl
      this.editProfile.form.english_lvl.value = profile.english_lvl
      this.editProfile.form.cv_link.value = profile.cv_link
      this.editProfile.form.allocations.value = profile.allocations
      this.editProfile.form.skills.value = profile.skills
    },
    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const fieldName = field['name']
        let fieldValue = fields[key]['value']

        if (Array.isArray(fieldValue) && key !== 'skills') {
          fieldValue = fieldValue.map(
            (item) => item[fields[key]['valueField']]
          )
        } else if (typeof fieldValue === 'object' && fieldValue) {
          let fieldKey = fields[key]['valueField']
          fieldValue = fieldKey
            ? fieldValue[fields[key]['valueField']]
            : fieldValue
        }

        data[fieldName] = fieldValue
      }
      if (fields['employment_type'] && fields['employment_type']['value'] && fields['employment_type']['value']['id'] !== 'partner') {
        delete data['partner_id']
      }

      return data
    },
    fetchUser (id) {
      return this.$api.users.getUser(id)
    },
    fetchUserProfile (id) {
      return this.$api.users.getUserProfile(id)
    },
    async updateUser (data) {
      const userId = data.id.value
      const formData = this.prepareDataForRequest(data)

      const savedUser = await this.$api.users.updateUser(userId, formData)
      this.setVisibleEditModal(false)
      return savedUser
    },
    async updateProfile (data) {
      const profileId = data.id.value
      const formData = this.prepareDataForRequest(data)
      const savedUser = await this.$api.users.updateUserProfile(profileId, formData)
      this.setVisibleEditModal(false)
      return savedUser
    }
  }
}
